export default "__VITE_ASSET__AMjbFZd1__"